import React from 'react';
import MissionCard from '../templates/MissionCard';
import SectionTitle from '../templates/SectionTitle';
import BtsTermsBox from '../templates/BtsTermsBox';
import { mockMissions, missionTerms } from '../data/mockData';
import './MissionsPage.css';

const TAB_LINKS = {
  2: 'team',
  3: 'ranking',
};

const MissionsPage = ({ onTabChange, onScanOpen, hasParty }) => {
  return (
    <div className="bts-missions">
      <SectionTitle icon="🎯">MISSIONS</SectionTitle>

      {mockMissions.map((mission) => {
        // Step 1 (ชวนเพื่อน id=2) = เปิดเสมอ
        // Step 2 (สแกนบิล id=1) + Step 3 (อันดับ id=3) = ต้องสร้างตี้ก่อน
        const isLocked = mission.id !== 2 && !hasParty;

        return (
          <MissionCard
            key={mission.id}
            {...mission}
            disabled={isLocked}
            onClick={
              isLocked ? undefined
              : mission.id === 1 && onScanOpen ? () => onScanOpen()
              : TAB_LINKS[mission.id] && onTabChange ? () => onTabChange(TAB_LINKS[mission.id])
              : undefined
            }
          />
        );
      })}

      <BtsTermsBox title="เงื่อนไข : การเข้าร่วมกิจกรรม" terms={missionTerms} />

      <div className="bts-missions__spacer" />
    </div>
  );
};

export default MissionsPage;
